import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { AppVersions } from "./types";

import { Data } from "@/shared/types.ts";
import api from "@/shared/api";

const APP_VERSIONS_KEY = "app_versions";

export function useAppVersions() {
  return useQuery<Data<AppVersions>>({
    queryKey: [APP_VERSIONS_KEY],
    queryFn: (ctx) =>
      api
        .get<
          Data<AppVersions>
        >("/api/v1/admin/app/versions", { signal: ctx.signal })
        .json(),
  });
}

export function useUpdateAppVersions() {
  const queryClient = useQueryClient();

  return useMutation<Data<AppVersions>, Error, AppVersions>({
    mutationFn: (versions) =>
      api.put("/api/v1/admin/app/versions", { json: versions }).json(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [APP_VERSIONS_KEY] });
    },
  });
}
